module.exports = __webpack_public_path__ + "static/media/f6de7688-db87-4e70-b586-58f35f42e9c4.f592d5ec.png";